








import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueFieldGroup';

@Component({ name: 'FieldLabel' })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true})
    field: string;

    @Prop({required: false})
    isRequired: boolean;

}
